<template>
  <!-- Informations -->
  <CardComponent v-if="utilisateur" :icon="PhUser" title="Mes informations">
    <CardInfoComponent title="Nom"
      >{{ utilisateur?.prenom }} {{ utilisateur?.nom }}</CardInfoComponent
    >
    <CardInfoComponent title="Identifiant">{{ utilisateur?.identifiant }}</CardInfoComponent>
  </CardComponent>
</template>

<script setup lang="ts">
import type { UtilisateurGet } from '@/interfaces/Utilisateur.ts'
import type { PropType } from 'vue'
import { PhUser } from '@phosphor-icons/vue'
import CardComponent from '@/components/card/CardComponent.vue'
import CardInfoComponent from '@/components/card/CardInfoComponent.vue'

defineProps({
  utilisateur: {
    type: Object as PropType<UtilisateurGet>,
    required: true,
  },
})
</script>
